import { useEffect, useState } from "react";
import { fetchItems, downloadItemsExcel } from "../Api/ViewItems";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import { Base_URL } from "../url";
import { FaTimes } from "react-icons/fa";
import { FaDownload } from "react-icons/fa6";
import "../Styling/AllTables.css"

const ViewItems = () => {
  const [items, setItems] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const {user}=useAuth();
  const loadItems = async () => {
      try {
        const data = await fetchItems(user?.organisationId);
        setItems(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Items`);
      }
    };
  useEffect(() => {
 

    loadItems();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadItemsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Items_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Items data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };
  const handleDelete=async(id)=>{
    const res=await axios.delete(`${Base_URL}/Item/DeleteItem/${id}`);
    if(res.status===200)
    {
        toast.success(`Item with ${id} deleted successfully`);
    }
    else
    {
      toast.error(`Error Deleting Item`);
    }
    loadItems();
  }
  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="header-background p-3 d-flex justify-content-between align-items-center">
      
              <span className="header-list-title">View Items</span>
              
              <Button
                className="gradient-btn"
                onClick={handleDownload}
                disabled={isDownloading || items.length === 0}
              >
                {isDownloading ? 'Downloading...' : (
                  <>
                    <FaDownload style={{ marginRight: "8px" }} />
                    Download Data
                  </>
                )}
              </Button>

            </div>

            {items.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                      <th>Actions </th>
                        <th>Item Code</th>
                        <th>Item Name</th>
                        <th>Item Type</th>
                        <th>SKU Unit</th>
                        <th>Item Group</th>
                        <th>Valuation Method</th>
                        <th>Status</th>
                        <th>Manufacturer</th>
                        <th>Tax Category</th>
                        <th>Weight</th>
                        <th>GTIN</th>
                        <th>Item Group 1</th>
                        <th>Item Group 2</th>
                        <th>Item Group 3</th>
                        <th>Item Indicator 1</th>
                        <th>Item Indicator 2</th>
                        <th>Item Indicator 3</th>
                        <th>Merchant Code</th>
                        <th>Country Code</th>
                        <th>Region Code</th>
                        <th>Pack Size</th>
                        <th>Brand Group</th>
                        <th>Brand</th>
                        

                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td><Button variant="outline-danger" title="Delete item" onClick={()=>handleDelete(item.itemCodeId)}><FaTimes></FaTimes></Button></td>
                          <td>{item.itemCode}</td>
                          <td>{item.itemName}</td>
                          <td>{item.itemType}</td>
                          <td>{item.skuUnit}</td>
                          <td>{item.itemGroup}</td>
                          <td>{item.valuationMethod}</td>
                          <td>{item.activeStatus}</td>
                          <td>{item.manufacturer}</td>
                          <td>{item.taxCategory}</td>
                          <td>{item.weight}</td>
                          <td>{item.gtin}</td>
                          <td>{item.itemGroup1}</td>
                          <td>{item.itemGroup2}</td>
                          <td>{item.itemGroup3}</td>
                          <td>{item.itemIndicator1}</td>
                          <td>{item.itemIndicator2}</td>
                          <td>{item.itemIndicator3}</td>
                          <td>{item.merchantCode}</td>
                          <td>{item.countryCode}</td>
                          <td>{item.regionCode}</td>
                          <td>{item.packSize}</td>
                          <td>{item.brandGroup}</td>
                          <td>{item.brand}</td>
                          
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No items found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewItems;